module.exports = __webpack_public_path__ + "static/media/solving_demo.16f59787.gif";